export const SENSOR_STATUS = {
  OPERATIVE: 'Operative',
  REPAIR: 'Repair',
  OFFLINE: 'Offline',
  DISABLED: 'Disabled',
};

export const STATUS_COLORS = {
  Operative: '#43a047',
  Repair: '#ffa726',
  Offline: '#e53935',
  Disabled: '#9e9e9e',
};

export const getStatusLabel = (status: string) => {
  switch (status) {
    case 'Operative':
      return SENSOR_STATUS.OPERATIVE;
    case 'Repair':
      return SENSOR_STATUS.REPAIR;
    case 'Offline':
      return SENSOR_STATUS.OFFLINE;
    case 'Disabled':
      return SENSOR_STATUS.DISABLED;
    default:
      return 'Offline';
  }
};
